import {connect} from "react-redux";
import React, {useEffect, useMemo, useRef, useState} from "react";
import dayjs from "dayjs";
import * as formatter from "../../../../config/formatter";
import * as o2Api from "../../../../api/api";
import {Loading} from "../../../../components/common";
import {CAlert, CButton, CCol, CForm, CFormSelect, CInputGroup, CInputGroupText} from "@coreui/react";
import StoreListWhere from "../../where/StoreListWhere";
import {DatePicker} from "antd";
import locale from "antd/es/date-picker/locale/ko_KR";
import {AgGridReact} from "ag-grid-react";
import StoreCornerListWhere from "../../where/StoreCornerListWhere";
import {gridColumnSum} from "../../../../config/common";

const RegisterSaleCl = (props) => {
    const gridRef = useRef();
    const containerStyle = useMemo(() => ({width: "100%", height: "100%"}), []);
    const [pos, setPos] = useState([{deviceId: "전체"}]);
    const [rowData, setRowData] = useState([]);
    const [error, setError] = useState({
        visible: false,
        message: ""
    });
    const [searchForm, setSearchForm] = useState({
        saleDt: dayjs().add(-1, "d")
    });

    const defaultColDef = {
        width: 100,
        resizable: true,
        sortable: true,
        filter: false,
        autoHeaderHeight: true
    };

    const [columnDefs] = useState([
        {field: "statTime", headerName: "영업일자", maxWidth: 80, cellClass: "static-cell"},
        {
            colId: "week",
            field: "statTime",
            headerName: "요일",
            maxWidth: 60,
            cellClass: "static-cell",
            valueFormatter: (e) => formatter.weekendFormatter(e, "YYYYMMDD"),
        },
        {colId: "storeCd", field: "storeCd", headerName: "매장코드", maxWidth: 80, cellClass: "static-cell"},
        {colId: "storeNm", field: "storeNm", headerName: "매장명",},
        {colId: "posCd", field: "posCd", headerName: "POS", maxWidth: 60, cellClass: "static-cell"},
        {colId: "closeYn", field: "closeYn", headerName: "마감구분", maxWidth: 80, hide: true, cellClass: "static-cell"},
        {colId: "closeYnNm", field: "closeYnNm", headerName: "마감구분", maxWidth: 80, cellClass: "static-cell"
            ,cellStyle: (e) => {
                if (e.value !== '일마감') {
                    return {color: "red", cursor: "pointer"};
                }
                return null;
            }
        },
        {field: "saleAmt", headerName: "총매출액", valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"},
        {field: "rejectAmt", headerName: "반품금액", valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"},
        {field: "dcAmt", headerName: "총할인액", valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"},
        {field: "vaultAmt", headerName: "실매출액", valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"},
        {field: "netAmt", headerName: "공급가액", valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"},
        {field: "vatAmt", headerName: "부가세액", valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"},
        {field: "taxAmt", headerName: "과세매출액", valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"},
        {field: "taxFreeAmt", headerName: "면세매출액", valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"},
        {
            colId: "openTime",
            field: "openTime",
            minWidth: 150,
            headerName: "개점일시",
            valueFormatter: (e) => formatter.timeFormatter(e, "YYYY-MM-DDTHH:mm:ss", "YYYY-MM-DD HH:mm:ss")
        },
        {
            colId: "closeTime",
            field: "closeTime",
            headerName: "마감일시",
            minWidth: 150,
            valueFormatter: (e) => formatter.timeFormatter(e, "YYYY-MM-DDTHH:mm:ss", "YYYY-MM-DD HH:mm:ss")
        }
    ]);

    useEffect(() => {
        if (props.selected.storeCd.length > 0) {
            getStoreDevice();
        }
    }, [props.selected.storeCd]);

    const handleSelect = (code, value) => {
        if (value === "C") {
            setSearchForm((state) => ({
                ...state,
                cmpCd: code, brandCd: "", storeCd: "", cornerCd: ""
            }));
        } else if (value === "B") {
            setSearchForm((state) => ({
                ...state,
                cmpCd: state.cmpCd, brandCd: code, storeCd: "", cornerCd: ""
            }));
        } else if (value === "S") {
            setSearchForm((state) => ({
                ...state,
                cmpCd: state.cmpCd, brandCd: state.brandCd, storeCd: code, cornerCd: ""
            }));
        } else if (value === "O") {
            setSearchForm((state) => ({
                ...state,
                cmpCd: state.cmpCd, brandCd: state.brandCd, storeCd: state.storeCd, cornerCd: code
            }));
        }
    };

    const getStoreDevice = () => {
        const {cmpCd, brandCd, storeCd} = props.selected;
        const params = {
            cmpCd: cmpCd,
            brandCd: brandCd,
            storeCd: storeCd,
            useYn: "Y"
        };
        props.setLoading(true);
        o2Api.getStoreDevice(params).then((result) => {
            const {responseBody, responseCode, responseMessage} = result.data;
            if (responseCode === "200") {
                // 성공
                setPos([{deviceId: ""}]);
                setPos((state) => state.concat(responseBody));

                props.setLoading(false);
            }
        });
    };

    const search = () => {
        setError({visible: false, message: ""});
        const {cmpCd, brandCd, storeCd, deviceId} = searchForm;
        console.log(">>> search :: ", cmpCd, brandCd, storeCd, deviceId);

        if (brandCd === undefined || brandCd.length === 0) {
            setError({
                visible: true,
                message: "조회시 휴게소는 반드시 선택하셔야 합니다."
            });
            return;
        }

        if (storeCd === undefined || storeCd.length === 0) {
            setError({
                visible: true,
                message: "조회시 매장은 반드시 선택하셔야 합니다."
            });
            return;
        }

        const params = {
            cmpCd: cmpCd,
            brandCd: brandCd,
            storeCd: storeCd,
            posCd: searchForm.deviceId === "전체" ? "" : deviceId,
            //saleDt: searchForm.saleDt.format("YYYYMMDD")
            fromSaleDt: searchForm.saleDt.format("YYYYMMDD"),
            toSaleDt: searchForm.saleDt.format("YYYYMMDD")
        };

        console.log("params:: " , params);

        props.setLoading(true);
        //o2Api.getCurrentDay(params).then((result) => {
        o2Api.getCloseDailySale(params).then((result) => {
            const {responseBody, responseCode, responseMessage} = result.data;
            console.log("result : ", responseBody);

            if (responseCode === "200") {
                // 성공
                setRowData(responseBody);
                props.setLoading(false);

                createFooterData(responseBody);
            }
        });
    };

    const create = () => {
        const {cmpCd, brandCd, storeCd, deviceId} = searchForm;

        console.log("pos.deviceId::; ", pos.deviceId);

        if (storeCd.length === 0) {
            alert("점포를 먼저 선택해주세요.");
            return;
        }

        if (deviceId === undefined || deviceId.length === 0 ) {
            alert("POS번호를 선택해주세요.");
            return;
        }

        if(confirm("수기로 마감자료를 생성하시겠습니까?\n수기마감 진행 시, POS마감자료는 삭제됩니다.")) {

            props.setLoading(true);
            const params = {
                cmpCd: cmpCd,
                brandCd: brandCd,
                storeCd: storeCd,
                saleDt: searchForm.saleDt.format("YYYYMMDD"),
                posCd: deviceId
            };
            console.log("마감자료 생성 시 >>> params :: ", params);

            try {
            // 전송
                o2Api.putSaleCl(params).then((result) => {
                    const {responseBody, responseCode, responseMessage} = result.data;
                    props.setLoading(false);
                    if (responseCode === "200") {
                        // 성공
                        alert("마감자료 생성을 완료했습니다.");
                        search();
                    } else {
                        alert("마감자료 생성을 실패했습니다.");
                    }
                }); //end putSaleCl
            } catch (e) {
                props.setLoading(false);
                console.error("e.message ::: ", e.message);
            } finally {
                props.setLoading(false);
            }


        } // End confirm
    } //End create

    const sum = (values, col) => {
        let sum = 0;
        values.forEach((value) => {
            sum += value[col]
        })
        return sum;
    }

    const [totalRowData] = useState([
        {storeCd: "합계"}
    ])

    const createFooterData = (data) => {
        const api = gridRef.current.api;
        const result = [];
        result.push({
            storeCd: "합계",
            saleAmt: gridColumnSum(data, 'saleAmt'),
            rejectAmt: gridColumnSum(data, 'rejectAmt'),
            dcAmt: gridColumnSum(data, 'dcAmt'),
            vaultAmt: gridColumnSum(data, 'vaultAmt'),
            netAmt: gridColumnSum(data, 'netAmt'),
            vatAmt: gridColumnSum(data, 'vatAmt'),
            payAmt: gridColumnSum(data, 'payAmt'),
            taxAmt: gridColumnSum(data, 'taxAmt'),
            taxFreeAmt: gridColumnSum(data, 'taxFreeAmt')
        });
        api.setPinnedBottomRowData(result);
    }

    return (
        <div style={containerStyle}>
            {error.visible ? <CAlert color="danger" dismissible={true}>{error.message}</CAlert> : null}
            <div className="d-md-flex justify-content-between p-1" style={{marginBottom: 10}}>
                <h5>마감자료 수기등록</h5>
            </div>
            <StoreCornerListWhere type={"S"} account={props.account} selected={searchForm}
                                  onSelect={(c, v) => handleSelect(c, v)}/>
            <div className={"row row-cols-lg-auto g-1 m-0 align-items-center"}>
                <CCol xs={12} md={6}>
                    <CInputGroup size={"sm"}>
                        <CInputGroupText style={{width: 80}}>조회일자</CInputGroupText>
                        <CInputGroupText style={{background: "white", height: 35}}>
                            <DatePicker bordered={false}
                                        separator={"~"}
                                        placeholder={""}
                                        locale={locale}
                                        value={searchForm.saleDt}
                                        onChange={(dayjs, dateString) => {
                                            setSearchForm((state) => ({
                                                ...state, saleDt: dayjs
                                            }));
                                        }}/>
                        </CInputGroupText>
                    </CInputGroup>
                </CCol>
                <CCol xs={12} md={6}>
                    <CInputGroup size={"sm"}>
                        <CInputGroupText style={{width: 80}}>포스번호</CInputGroupText>
                        <CFormSelect value={searchForm.deviceId}
                                     onChange={(e) => {
                                         setSearchForm((state) => ({
                                             ...state,
                                             deviceId: e.target.value
                                         }));
                                     }}
                        >
                            {pos.map((p, index) => {
                                return (
                                    <option key={index} value={p.deviceId}>{p.deviceId}</option>
                                );
                            })}
                        </CFormSelect>
                    </CInputGroup>
                </CCol>
                <div className={"d-grid d-lg-flex gap-1"}>
                    <CButton style={{minWidth: 50, height: 35}} size={"sm"} color={"primary"} onClick={search}>조회</CButton>
                    <CButton style={{minWidth: 50, height: 35}} size={"sm"} color={"primary"} onClick={create}>마감자료 생성</CButton>
                </div>
            </div>

            <div style={{height: 10}}/>
            <h6><span style={{color: "red"}}>*</span>[매출현황 > 당일-매출상세] 데이터를 기반으로 마감 자료를 생성합니다. </h6>
            <h6><span style={{color: "red"}}>*</span>마감자료 수기등록 시, 해당 데이터로 최종 마감되니 참고 바랍니다.</h6>
            <div>
                <div className="ag-theme-alpine" style={{width: "100%", height: 500, marginTop: 10}}>
                    <AgGridReact
                        ref={gridRef}
                        rowSelection={"single"}
                        headerHeight={30}
                        rowHeight={30}
                        rowData={rowData}
                        animateRows={true}
                        enableRangeSelection={true}
                        enableCellTextSelection={true}
                        suppressClipboardPaste={true}
                        localeText={{noRowsToShow: "조회 결과가 없습니다."}}
                        pinnedBottomRowData={totalRowData}
                        defaultColDef={defaultColDef}
                        columnDefs={columnDefs}>
                    </AgGridReact>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    const {account, store, selected} = state;
    return {
        account, store, selected
    };
};

export default connect(mapStateToProps, null)(RegisterSaleCl);
